
import './Switch.scss';

const Switch = (props) => {
  const {label, onChange} = props || {}

  return (
    <div className='switch-wrapper'>
      <label for="toggle" class="switch-label">{label}</label>
      <div className='switch-input-wrapper'>

      <input type="checkbox" id="toggle" class="checkbox" defaultChecked onChange={onChange}/>  
      <label for="toggle" class="switch"/>
      </div>
    </div>
  );
};

export default Switch;